import type { ImageLoader } from 'next/image';

/**
 * Generates image URLs with the correct format and width parameters,
 * so the browser requests only the size it needs.
 * SVG images are excluded from resizing.
 * The original Contentful CDN domain is preserved — no /_next/image proxy is used.
 */
export const contentfulImageResponsiveUrl: ImageLoader = ({ src, width }) => {
    try {
        const urlObj = new URL(src);
        if (urlObj.pathname.endsWith('.svg')) {
            return src;
        }
        urlObj.searchParams.set('fm', 'webp');
        urlObj.searchParams.set('w', String(width));

        return urlObj.toString();
    } catch {
        return src;
    }
};
